import {CheckoutOrderHandler} from "./checkoutOrderHandler";
import moment from "moment";
import {__loco} from "../../utils/localization";
import { SERVICE_CATEGORIES } from '../../adlevo-vue/appConfiguration';

/**
 * Class rendering guests information form and handling events and functionality related to it.
 */
export class CheckoutGuestsInformationForm {

  /**
   * Initialize selectors
   */
  constructor() {
    this.selectors = {
      formItemsContainer: '.checkout__guest-info_tour-group',
      stepsContainer: '#desktop-steps',

      // @todo: Remove mobile dependency.
      checkoutMobileBottom: '.checkout__mobile_bottom'
    };

    /**
     * Overwrite selectors on mobile
     */
    if ($(window).width() < 600) {
      // @todo: Remove mobile dependency.
      // this.selectors.stepsContainer = '#mobile-steps';
    }

    /**
     * Will contain all invalid items
     * @type {Array}
     */
    this.invalidItems = [];
  }

  /**
   * @todo: Remove this.
   */
  mock() {
    // new CheckoutMockery();
  }

  /**
   * Set response items
   *
   * @param items
   * @returns {CheckoutGuestsInformationForm} this instance
   */
  setItems(items) {
    this.items = items;
    return this;
  }

  /**
   * Check if items are set
   *
   * @returns {boolean}
   */
  hasItems() {
    return !!this.items;
  }

  /**
   * Set validator instance
   *
   * @param {CheckoutItemsValidator} validator
   */
  setValidator(validator) {
    this.validator = validator;
    return this;
  }

  /**
   * Check if validator is set
   *
   * @returns {boolean}
   */
  hasValidator() {
    return !!this.validator;
  }

  /**
   * Listen for DOM Events
   */
  listen() {

  }

  /**
   * Will render guests information form
   */
  renderForm() {
    if (this.hasItems()) {
      const blocks = [];

      this.items.forEach((cartItem) => {
        /**
         * If item should not be rendered - return an empty string
         */
        if (this.shouldRenderItem(cartItem)) {
          // blocks.push(this.renderFormTourBlock(item));
        } else {
          // this.invalidItems.push(cartItem);
        }
      });

      /**
       * Handle scenario when all items added to cart are invalid.
       */
      if (this.invalidItems.length === Object.keys(this.items).length) {
        this.renderAllItemsAreInvalid();
      } else {
        $(this.selectors.formItemsContainer).html(blocks.join(''));
      }
    }

    return this;
  }

  /**
   * Render output for the scenario when all items that were added to cart are now invalid.
   *
   * @returns {string}
   */
  renderAllItemsAreInvalid() {
    const $message = (`
    <div class="checkout__h3"> ${__loco('Sorry, looks like all of the items you have added to cart are outdated.')}</div>
    `);

    $(this.selectors.stepsContainer).html($message);
    $(this.selectors.checkoutMobileBottom).hide();
  }

  /**
   * Defines requirements for an item to be rendered.
   *
   * @param cartItem
   * @returns {boolean}
   */
  shouldRenderItem(cartItem) {
    switch (cartItem.type) {
      case SERVICE_CATEGORIES.ACTIVITIES:
        return cartItem.status && !!cartItem.tour;
      case SERVICE_CATEGORIES.HOTELS:
        cartItem.getRooms().forEach(roomType => {
          if(!roomType.status){
            return false;
          }
        });
        return true;
    }
  }

  /**
   * Render a tour block for the form.
   *
   * @todo: Render child age.
   * @param item - Checkout validation response items
   * @returns {string}
   */
  renderFormTourBlock(item) {
    const {tour: {kids_age_from, kids_not_allowed}} = item;

    const getChildrenAgesOptionList = () => {
      let text = '';
      let counter = !kids_not_allowed ? kids_age_from : 0;
      while (counter <= 17) {
        text += `<option value="${counter}">${counter} ${counter === 1 ? 'year' : 'years'}</option>`;
        counter += 1;
      }
      return text;
    };

    console.log('item is');
    console.log(item);

    let startTime = moment(item.tour.start_time, 'HH:mm:ss').format('hh:mm A');

    /**
     * check if an option was added to cart
     */
    if (item.tour_option !== undefined) {
      startTime = moment(item.tour_option.start_time, 'HH:mm:ss').format('hh:mm A');
    }

    let pickupLocationPicker = ``;
    let hasPickupOptionsClass = '';
    let guestsInformationTitle = ``;
    let scheduledPickupTime = ``;


    if (item.tour.has_pickup_options) {

      // add has pickup options class
      hasPickupOptionsClass = 'has_pickup_options';

      // add guests information header
      guestsInformationTitle = `
        <h4 class="checkout__guest-info_tour__title checkout__guest-info_guests__title">${__loco('Guests')}</h4>
      `;


      // calculate pickup time for the first available pickup option
      let firstPickupOption = item.tour.pickup_options[0];
      let scheduledPickupTimeMoment = moment(startTime, 'hh:mm A').add(firstPickupOption.schedule, 'minutes').format('hh:mm A');
      scheduledPickupTime = `<span class="scheduled_pickup_time" data-start-time="${startTime}">, pickup (approx): ${scheduledPickupTimeMoment}</span>`;


      // create pickup location picker
      pickupLocationPicker = (`
      <div class="select-zone child">
        <span class="checkout__item_label">${__loco('Pickup location')}</span>
        <select class="select-zone__select checkout-tour-pickup-option-select">
          ${item.tour.pickup_options.map((option) => {
            let arrivalTime = '08:00';
            return (`
                <option data-schedule="${option.schedule}" value="${option.id}">${option.display_name}</option>          
              `);
          }).join('')
        }
          </select>
      </div>

      `);
    }


    /**
     * On pickup option change - re-calculate pickup option
     */
    $(document).on('change', '.checkout-tour-pickup-option-select', function(){
      const $this = $(this);
      const $tourCard = $this.closest('.checkout__guest-info_tour.has_pickup_options');
      const $scheduledPickupTime = $tourCard.find('.scheduled_pickup_time');
      const selected = $this.find('option:selected');

      const startTime = $scheduledPickupTime.data('start-time');
      const schedule = selected.data('schedule');

      let scheduledPickupTimeMoment = moment(startTime, 'hh:mm A').add(schedule, 'minutes').format('hh:mm A');

      $scheduledPickupTime.html(`, ${__loco('pickup (approx)')}: ${scheduledPickupTimeMoment}`);
    });


    return (`
      <div class="checkout__guest-info_tour ${hasPickupOptionsClass}" data-tour-item="${item.tour.id}">
        <div class="checkout__guest-info_tour__header">
          <h4 class="checkout__guest-info_tour__title">
              ${item.tour.name} <span class="starttime"> - ${startTime}${scheduledPickupTime}</span>  
          </h4>
          ${pickupLocationPicker}
        </div>
        ${guestsInformationTitle}
        <div class="checkout__flex-no-pad">
          <div class="checkout__guest-info_adults">
            ${Array(item.request.adults).fill().map(() => `
              <div class="checkout__item_wrapper checkout__guest-info_tour__adult">
                <div class="checkout__item adult">
                  <span class="checkout__item_label">${__loco('Adult name')}</span>
                  <input
                    class="checkout__item_input validate name-input"
                    data-type="letters-required"
                    type="text"
                    placeholder="${__loco('Full Name')}"
                  >
                </div>
                <span class="form-field__error --payment" style="display: none;">${__loco('Please check the field')}</span>
              </div>
            `).join('')}
          </div>
          <div class="checkout__guest-info_children">
            ${Array(item.request.children).fill().map(() => `
              <div class="checkout__guest-info_tour__child">
                <div class="checkout__item_wrapper name-wrapper">
                  <div class="checkout__item child">
                    <span class="checkout__item_label">${__loco('Child name')}</span>
                    <input
                      class="checkout__item_input validate name-input"
                      data-type="letters-required"
                      type="text"
                      placeholder="${__loco('Full Name')}"
                    >
                  </div>
                  <span class="form-field__error --payment" style="display: none;">${__loco('Please check the field')}</span>
                </div>
                
                <div class="checkout__item_wrapper age-wrapper">
                  <div class="select-zone child">
                    <span class="checkout__item_label">${__loco('Child age')}</span>
                    <select class="select-zone__select">
                      <option value="" hidden disabled>${__loco('Select child age')}</option>
                      ${getChildrenAgesOptionList()}
                    </select>
                  </div>
                </div>
              </div>
            `).join('')}
          </div>
        </div>
      </div>
    `);
  }
}